module.exports = __webpack_public_path__ + "static/media/CM Foundation Stone.dc8880c5.svg";